import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../components/AppIcon';

/**
 * Panneau plein écran mobile (portal, safe-area, fond opaque).
 */
export default function WorkshopFullScreenSheet({ open, onClose, title, subtitle, children, footer }) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  const sheet = (
    <div
      className="fixed inset-0 z-[100] flex flex-col bg-background isolate"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <header className="shrink-0 flex items-center gap-3 px-4 py-3 border-b border-border bg-card shadow-sm pt-[max(0.75rem,env(safe-area-inset-top))]">
        <button
          type="button"
          onClick={onClose}
          className="min-h-[44px] min-w-[44px] flex items-center justify-center rounded-xl bg-muted/60 hover:bg-muted cursor-pointer"
          aria-label="Fermer"
        >
          <Icon name="X" size={22} />
        </button>
        <div className="flex-1 min-w-0 pr-1">
          <h2 className="text-base font-semibold text-foreground leading-tight truncate">{title}</h2>
          {subtitle ? (
            <p className="text-xs text-muted-foreground truncate mt-0.5">{subtitle}</p>
          ) : null}
        </div>
      </header>
      <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain bg-background">
        <div className="max-w-lg mx-auto w-full px-4 py-4 pb-6">{children}</div>
      </div>
      {footer ? (
        <footer className="shrink-0 border-t border-border bg-card shadow-[0_-4px_16px_rgba(0,0,0,0.06)] px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
          <div className="max-w-lg mx-auto w-full">{footer}</div>
        </footer>
      ) : null}
    </div>
  );

  return createPortal(sheet, document.body);
}
